import { Link } from "react-router-dom";
import { aboutStats } from "@/mocks/site/content";

const ABOUT_HERO_IMG =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20group%20photo%20illustration%20of%20a%20diverse%20professional%20moving%20company%20team%20wearing%20matching%20cream%20colored%20uniforms%20standing%20in%20front%20of%20a%20vintage%20moving%20truck%20at%20golden%20hour%20painterly%20texture%20rich%20warm%20earth%20tones%20cream%20and%20burnt%20orange%20palette%20artistic%20cinematic%20wide%20composition%20professional%20team%20portrait%20with%20soft%20directional%20warm%20golden%20sunset%20light&width=1800&height=1100&seq=about-hero&orientation=landscape";

export default function AboutHero() {
  return (
    <section className="relative pt-28 md:pt-36 pb-16 md:pb-20 bg-[#FAF5EC] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-xs font-semibold text-ink-500 mb-6">
          <Link to="/" className="hover:text-brand-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-ink-900">About</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              Family-owned since 2007
            </div>
            <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-ink-900 leading-[1.05] tracking-tight">
              We started with one truck and a stubborn belief that moving shouldn't suck.
            </h1>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-ink-600 leading-relaxed">
              19 years and 12,400+ moves later, we still answer the phone ourselves, still pay our crews well above market rate, and still treat every move like it's the only one we have today.
            </p>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden h-[360px] md:h-[520px] mb-14">
          <img src={ABOUT_HERO_IMG} alt="Haulmark team in front of moving truck" className="w-full h-full object-cover object-top" />
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 pt-2">
          {aboutStats.map((s) => (
            <div key={s.label} className="border-t border-ink-200 pt-5">
              <div className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-none mb-2">
                {s.value}
              </div>
              <div className="text-[11px] uppercase tracking-[0.16em] text-ink-500 font-semibold">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}